import React, { PureComponent } from 'react';

import { PropTypes as MobxPropTypes } from 'mobx-react';

import { CampaignListActions } from './listActions';
import { CampaignListItem } from './listItem';

import CampaignsService from '../../CampaignsService';
import { CAMPAIGNS_STATUS } from '../../constants';
import { CampaignModal } from '../campaignModal';

import './CampaignList.scss';

class CampaignList extends PureComponent {
  static propTypes = {
    list: MobxPropTypes.objectOrObservableObject,
    numberOfSales: MobxPropTypes.objectOrObservableObject,
    ids: MobxPropTypes.arrayOrObservableArray
  };

  state = {
    openModal: false,
    selectedCampaign: null
  };

  get selectedCampaign() {
    const { list } = this.props;
    const { selectedCampaign } = this.state;

    return list[selectedCampaign] || {};
  }

  handleOpenModal = (campaignId) => {
    return () => {
      this.setState({ openModal: true, selectedCampaign: campaignId });
    };
  };

  handleCloseModal = () => {
    this.setState({ openModal: false, selectedCampaign: null });
  };

  handleConfirmModal = async () => {
    const { campaignId, status } = this.selectedCampaign;

    await (status === CAMPAIGNS_STATUS.ENABLED
      ? CampaignsService.inactiveCampaign(campaignId)
      : CampaignsService.activeCampaign(campaignId));

    this.handleCloseModal();
  };

  renderListItem = (campaignId) => {
    const { list } = this.props;
    const campaign = list[campaignId];
    const numberOfSales = this.props.numberOfSales[campaignId] || null;

    if (!campaign) {
      return null;
    }

    return (
      <div
        key={campaignId}
        className="campaigns_list__item_container"
        data-test="campaign-item"
      >
        <CampaignListItem
          campaignId={campaignId}
          name={campaign.name}
          status={campaign.status}
          type={campaign.type}
          numberOfSales={numberOfSales}
        />
        <CampaignListActions
          className="campaigns_list__item_actions"
          campaignStatus={campaign.status}
          visualizeLink={campaign.visualizeLink}
          handleToggleStatus={this.handleOpenModal(campaignId)}
        />
      </div>
    );
  };

  render() {
    const { ids, list } = this.props;
    const { openModal } = this.state;
    const { name, status } = this.selectedCampaign;

    if (!list) {
      return null;
    }

    return (
      <div className="campaigns_list">
        {ids.map(this.renderListItem)}
        {openModal && (
          <CampaignModal
            onConfirm={this.handleConfirmModal}
            onClose={this.handleCloseModal}
            name={name}
            status={status}
          />
        )}
      </div>
    );
  }
}

export default CampaignList;
